// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  padding: 0 10px;
}

.toolbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  background: white;
  align-items: center;
  box-shadow: 0px -4px 15px 0px rgba(79, 97, 79, 0.2509803922);
}
.toolbar p {
  margin: 0px;
  color: var(--ion-color-secondary) !important;
}

.promo-info {
  align-items: center;
  padding: 10px 17px;
  background: white;
  margin: 10px 10px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  display: none;
}
.promo-info .name {
  width: 180px;
}

.min-order {
  margin: 10px 10px 0;
}

.add-more {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 34px;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding-inline: 7px;
  cursor: pointer;
  border-radius: 22px;
  background-color: var(--ion-color-primary);
  padding: 10px;
}
.add-more .add-text {
  font-family: AppFontBold;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0px;
  text-align: left;
  color: white;
}
.add-more .add-button {
  margin-right: 12px;
}

.card-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wrapper-block {
  height: 100%;
}
@media (max-width: 992px) {
  .wrapper-block .height-block {
    height: 100% !important;
  }
}

.wrapper {
  max-height: 100%;
  height: 100%;
}
@media (max-width: 992px) {
  .wrapper {
    padding-top: 20px;
    padding-bottom: 0px;
    background: #faf7f6;
  }
}
.wrapper .border-line {
  border-radius: 35px;
  height: auto;
  max-height: auto;
  flex-direction: column;
  display: flex;
  background-size: cover;
  overflow: hidden;
  position: relative;
}
@media (max-width: 992px) {
  .wrapper .border-line {
    background: #f6f1ef;
    box-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;
  }
}
@media (max-width: 992px) {
  .wrapper .border-line {
    overflow: auto !important;
  }
}
@media (min-width: 991px) {
  .wrapper .border-line {
    height: calc(100% - 10px);
  }
}
.wrapper .border-line .cross-selector {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  width: 25px;
  height: 25px;
  padding: 0px;
  z-index: 99;
  cursor: pointer;
}
@media (max-width: 992px) {
  .wrapper .border-line {
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}

.time-selection {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 30px 18px 10px;
}
.time-selection .plump {
  height: 51px;
  width: 54px;
  margin-right: 24px;
}
.time-selection .time-selection-text-block {
  flex-grow: 1;
}
.time-selection .time-selection-text {
  font-family: Title;
  font-size: 32px;
  line-height: 110%;
  letter-spacing: 2%;
  vertical-align: middle;
  text-transform: uppercase;
  vertical-align: baseline;
}
.time-selection .table-number {
  color: var(--ion-color-primary);
}

.order-list {
  width: 100%;
}

.promo-code {
  width: 100%;
}

.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}

.ordered-articles {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 18px;
  background-color: #ffffff;
  border: 1px solid #e8e8df;
  border-radius: 15px 15px 0 0;
}
@media (max-width: 992px) {
  .ordered-articles {
    min-height: 150px;
  }
}

.ordered-articles-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-family: AppFontBold;
  font-size: 25px;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color: #000;
  margin-bottom: 18px;
}

.promo-error {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: red;
  display: none;
}

.no-articles {
  display: flex;
}
.no-articles ion-icon {
  color: white;
  fill: white;
  margin-right: 10px;
  display: none;
}
@media (min-width: 991px) {
  .no-articles ion-icon {
    fill: black;
    color: black;
  }
}
@media (min-width: 991px) {
  .no-articles ion-icon.big-screen {
    display: block;
  }
}
@media (max-width: 992px) {
  .no-articles ion-icon.small-screen {
    display: block;
  }
}
.no-articles h3 {
  color: var(--color-black);
  font-family: AppFont;
  font-size: 16px;
}

.footer-finish-btn {
  padding: 10px 20px;
}
.footer-finish-btn .footer-btn {
  width: 100%;
}
.footer-finish-btn .footer-btn:hover {
  --background: var(--primary-btn) !important;
}
.footer-finish-btn .footer-btn .footer-btn-text {
  font-size: 14px !important;
  color: white;
  font-family: AppFont, sans-serif;
}

.finish-btn {
  padding: 10px 20px;
  border-bottom: 1px solid #ebdfda;
}
@media (max-width: 992px) {
  .finish-btn {
    display: none;
  }
}
.finish-btn .footer-btn {
  width: 100%;
}
.finish-btn .footer-btn .footer-btn-text {
  font-size: 14px !important;
  color: white;
  font-family: AppFont, sans-serif;
}

.promo-section {
  border-top: 1px solid var(--color-black);
  border-bottom: 1px solid var(--color-black);
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (max-width: 992px) {
  .promo-section {
    padding: 5px 20px;
  }
}
.promo-section.no-border {
  border-top: none;
}
.promo-section ion-icon {
  width: 30px;
  height: 30px;
}
.promo-section h3 {
  margin-left: 10px;
  font-size: 16px;
  font-family: AppFont, sans-serif;
  text-transform: uppercase;
}
@media (max-width: 992px) {
  .promo-section h3 {
    font-size: 14px;
  }
}

.tips {
  padding: 10px 20px 0px;
}

.kaisin-points {
  padding: 8px 15px;
}
.kaisin-points .wrapper-kaisin-block {
  background: #ebdfda;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.kaisin-points .wrapper-kaisin-block .left-info {
  padding: 5px 20px;
  width: 60%;
  text-transform: uppercase;
}
.kaisin-points .wrapper-kaisin-block .left-info h3 {
  font-family: AppFontMedium;
  font-weight: bold;
  font-size: 14px;
}
.kaisin-points .wrapper-kaisin-block .left-info p {
  font-size: 10px;
  font-family: AppFont;
}
.kaisin-points .wrapper-kaisin-block .right-info {
  padding: 5px 20px;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.kaisin-points .wrapper-kaisin-block .right-info ion-img {
  width: 50px;
  height: 50px;
}
.kaisin-points .wrapper-kaisin-block .right-info p {
  padding-right: 5px;
  font-weight: bold;
}
.kaisin-points .wrapper-kaisin-block .register-section {
  width: 100%;
  padding: 8px 10px;
  border-top: 1px solid var(--color-black);
  display: flex;
  justify-content: space-between;
}
.kaisin-points .wrapper-kaisin-block .register-section ion-button {
  --background: transparent;
  color: var(--color-black);
  min-height: 28px;
  font-size: 12px;
  width: 48%;
}

.delete-promo {
  justify-content: space-between;
}
.delete-promo .delete-items-section {
  display: flex;
  align-items: center;
}
.delete-promo .delete-items-section ion-icon {
  margin-left: 15px;
}

.form-section-input .form-section-title {
  padding-top: 15px;
  padding-bottom: 20px;
  border-top: 1px solid var(--color-black);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 992px) {
  .form-section-input .form-section-title {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
.form-section-input .form-section-title .rotate-icon {
  rotate: 0deg;
  transition: rotate 0.5s ease-in-out;
}
.form-section-input .form-section-title .rotate-icon.rotate {
  rotate: 180deg;
}
.form-section-input h3 {
  font-size: 16px;
  text-transform: uppercase;
  color: var(--color-black);
}
.form-section-input .input-forms {
  max-height: auto;
  height: -moz-fit-content;
  height: fit-content;
  transition: opacity 0.1s ease-in-out, max-height 0.5s cubic-bezier(0, 1, 0, 1);
}
.form-section-input .input-forms.hide {
  height: 0px;
  min-height: 0px;
  min-height: 0px;
  max-height: 0px;
  opacity: 0;
  overflow: hidden;
}
.form-section-input .input-forms .top-form-wrapper {
  padding: 0 16px;
}
.form-section-input .input-forms ion-label {
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-black);
}
.form-section-input .input-forms .title-label {
  font-family: AppFontBold;
  font-size: 16px;
}

.address-selection {
  padding: 13px 20px;
}
.address-selection h3 {
  font-size: 14px;
}

.name_row {
  padding: 10px 10px 13px 15px;
  color: var(--color-black);
  display: flex;
  align-items: center;
  border-top: 1px solid var(--color-black);
}

.name-block b {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--ion-color-main);
}

.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
}
.circle ion-icon {
  width: 30px;
  height: 30px;
}

.error_container {
  margin: 0;
  margin-top: 5px;
  margin-bottom: 5px;
}

.added-gift {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  border-bottom: 1px solid var(--color-black);
  cursor: pointer;
}
.added-gift .header-gift {
  width: 35px;
  height: 35px;
  min-height: 35px;
  min-width: 35px;
  background: #f48b7f;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.added-gift .inner-text-gift {
  margin-left: 5px;
}
.added-gift .inner-text-gift h3 {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .inner-text-gift p {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .delete-items-section {
  margin-left: auto;
}
.added-gift ion-icon {
  width: 25px;
  height: 25px;
}

.error-message {
  text-align: center;
  color: var(--ion-color-secondary);
  padding-bottom: 5px;
  font-size: 12px;
}

.promo-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  padding-block: 13px;
  margin-inline: 18px;
  margin-bottom: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.3019607843);
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}
.promo-block ion-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
}
.promo-block .promo-text {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
}
.promo-block ion-img {
  width: 50px;
  margin-right: auto;
}
.promo-block .delete-items-section {
  margin-left: auto;
}

.button-row {
  padding: 20px 18px;
  border-top: 1px solid rgba(0, 0, 0, 0.3019607843);
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}

.sub-total {
  padding: 0;
  margin-bottom: 8px;
}
.sub-total .sub-total-title,
.sub-total .sub-total-sum {
  font-family: AppFont;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
}

.total {
  padding: 0;
}
.total .total-title,
.total .total-sum {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.total-points {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0px 20px;
  text-transform: uppercase;
}
.total-points span {
  color: #f48b7f;
  font-size: 12px;
}

.quantity {
  width: 25px;
  height: 25px;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  background: var(--color-background-alt);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: var(--color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-content/order-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,eAAA;AADD;;AAGA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4DAAA;AAAD;AACC;EACC,WAAA;EACA,4CAAA;AACF;;AAEA;EACC,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAMA,aAAA;AAJD;AAAC;EACC,YAAA;AAEF;;AAIA;EACC,mBAAA;AADD;;AAIA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;AADD;AAEC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAAF;AAGC;EACC,kBAAA;AADF;;AAKA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAFD;;AAKA;EACC,YAAA;AAFD;AC9DE;EDiED;IAEE,uBAAA;EADD;AACF;;AAIA;EACC,gBAAA;EAEA,YAAA;AAFD;ACxEE;EDuEF;IAOE,iBAAA;IACA,mBAAA;IACA,mBAAA;EAFA;AACF;AAGC;EAMC,mBAAA;EAEA,YAAA;EACA,gBAAA;EAQA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAdF;ACzFE;EDkFD;IAGE,mBAAA;IACA,8CAAA;EAQD;AACF;AC/FE;EDkFD;IAWE,yBAAA;EAMD;AACF;AC1GE;EDwFD;IAcE,yBAAA;EAQD;AACF;AADE;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAGH;ACpHE;EDkFD;IAkCE,mBAAA;IACA,8BAAA;IACA,+BAAA;EAID;AACF;;AAAA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;AAGD;AAFC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAIF;AADC;EACC,YAAA;AAGF;AAAC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;AAEF;AACC;EACC,+BAAA;AACF;;AAGA;EACC,WAAA;AAAD;;AAGA;EACC,WAAA;AAAD;;AAEA;EACC,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACD;ACtKE;EDgKF;IAOE,YAAA;EAGA;AACF;;AAAA;EACC,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;AAGD;ACvLE;ED2KF;IAYE,iBAAA;EAIA;AACF;;AADA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAID;;AADA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAID;;AADA;EACC,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AAID;;AADA;EACC,aAAA;AAID;AAHC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EAMA,aAAA;AAAF;ACrOE;ED4ND;IAME,WAAA;IACA,YAAA;EAOD;AACF;AC3OE;EDsOA;IAEE,cAAA;EAOF;AACF;AC1OE;EDqOA;IAEE,cAAA;EAOF;AACF;AAJC;EACC,yBAAA;EACA,oBAAA;EACA,eAAA;AAMF;;AAHA;EACC,kBAAA;AAMD;AAJC;EAIC,WAAA;AAGF;AANE;EACC,2CAAA;AAQH;AALE;EACC,0BAAA;EACA,YAAA;EACA,gCAAA;AAOH;;AACA;EACC,kBAAA;EAYA,gCAAA;AATD;ACxQE;EDoQF;IAGE,aAAA;EAKA;AACF;AAJC;EACC,WAAA;AAMF;AALE;EACC,0BAAA;EACA,YAAA;EACA,gCAAA;AAOH;;AAFA;EACC,wCAAA;EACA,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAKD;AC9RE;EDmRF;IAQE,iBAAA;EAOA;AACF;AANC;EACC,gBAAA;AAQF;AANC;EACC,WAAA;EACA,YAAA;AAQF;AANC;EACC,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AAQF;AChTE;EDoSD;IAME,eAAA;EAUD;AACF;;AAPA;EACC,sBAAA;AAUD;;AARA;EACC,iBAAA;AAWD;AATC;EACC,mBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAUF;AATE;EACC,iBAAA;EACA,UAAA;EACA,yBAAA;AAWH;AAVG;EACC,0BAAA;EACA,iBAAA;EACA,eAAA;AAYJ;AAVG;EACC,eAAA;EACA,oBAAA;AAYJ;AATE;EACC,iBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAWH;AAVG;EACC,WAAA;EACA,YAAA;AAYJ;AAVG;EACC,kBAAA;EACA,iBAAA;AAYJ;AATE;EACC,WAAA;EACA,iBAAA;EACA,wCAAA;EACA,aAAA;EACA,8BAAA;AAWH;AAVG;EACC,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAYJ;;AANA;EACC,8BAAA;AASD;AARC;EACC,aAAA;EACA,mBAAA;AAUF;AATE;EACC,iBAAA;AAWH;;AANC;EACC,iBAAA;EACA,oBAAA;EACA,wCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AASF;ACpYE;EDqXD;IASE,gBAAA;IACA,mBAAA;EAUD;AACF;AATE;EACC,YAAA;EACA,mCAAA;AAWH;AAVG;EACC,cAAA;AAYJ;AARC;EACC,eAAA;EACA,yBAAA;EACA,yBAAA;AAUF;AARC;EACC,gBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,8EAAA;AAUF;AATE;EACC,WAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AAWH;AARE;EACC,eAAA;AAUH;AAPE;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AASH;AANE;EACC,wBAAA;EACA,eAAA;AAQH;;AAJA;EACC,kBAAA;AAOD;AANC;EACC,eAAA;AAQF;;AAJA;EACC,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;AAOD;;AAJC;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;AAOF;;AAHA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,YAAA;AAKD;AAJC;EACC,WAAA;EACA,YAAA;AAMF;;AAFA;EACC,SAAA;EACA,eAAA;EACA,kBAAA;AAKD;;AAFA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,2CAAA;EACA,eAAA;AAKD;AAJC;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAMF;AAJC;EACC,gBAAA;AAMF;AALE;EACC,0BAAA;EACA,yBAAA;EACA,eAAA;AAOH;AALE;EACC,0BAAA;EACA,yBAAA;EACA,eAAA;AAOH;AAJC;EACC,iBAAA;AAMF;AAJC;EACC,WAAA;EACA,YAAA;AAMF;;AAHA;EACC,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,eAAA;AAMD;;AAJA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iDAAA;EACA,oDAAA;AAMD;AAJC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAMF;AAJC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAMF;AAJC;EACC,WAAA;EACA,kBAAA;AAMF;AAJC;EACC,iBAAA;AAMF;;AAFA;EACC,kBAAA;EACA,iDAAA;EACA,oDAAA;AAKD;;AAFA;EACC,UAAA;EACA,kBAAA;AAKD;AAJC;;EAEC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAMF;;AAFA;EACC,UAAA;AAKD;AAHC;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAKF;;AADA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;AAID;AAFC;EACC,cAAA;EACA,eAAA;AAIF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AAGF","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n\tpadding: 0 10px;\n}\n.toolbar {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px 20px;\n\tbackground: white;\n\talign-items: center;\n\tbox-shadow: 0px -4px 15px 0px #4f614f40;\n\tp {\n\t\tmargin: 0px;\n\t\tcolor: var(--ion-color-secondary) !important;\n\t}\n}\n.promo-info {\n\talign-items: center;\n\tpadding: 10px 17px;\n\tbackground: white;\n\tmargin: 10px 10px 0;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\n\t.name {\n\t\twidth: 180px;\n\t}\n\n\tdisplay: none;\n}\n\n.min-order {\n\tmargin: 10px 10px 0;\n}\n\n.add-more {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\theight: 34px;\n\tmin-width: fit-content;\n\tpadding-inline: 7px;\n\tcursor: pointer;\n\tborder-radius: 22px;\n\tbackground-color: var(--ion-color-primary);\n\tpadding: 10px;\n\t.add-text {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\t\tletter-spacing: 0px;\n\t\ttext-align: left;\n\t\tcolor: white;\n\t}\n\n\t.add-button {\n\t\tmargin-right: 12px;\n\t}\n}\n\n.card-actions {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n.wrapper-block {\n\theight: 100%;\n\t.height-block {\n\t\t@include mobile {\n\t\t\theight: 100% !important;\n\t\t}\n\t}\n}\n.wrapper {\n\tmax-height: 100%;\n\n\theight: 100%;\n\t// padding: 20px;\n\t// display: flex;\n\t@include mobile {\n\t\tpadding-top: 20px;\n\t\tpadding-bottom: 0px;\n\t\tbackground: #faf7f6;\n\t}\n\t.border-line {\n\t\t@include mobile {\n\t\t\t// border: 1px solid var(--color-black);\n\t\t\tbackground: #f6f1ef;\n\t\t\tbox-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;\n\t\t}\n\t\tborder-radius: 35px;\n\n\t\theight: auto;\n\t\tmax-height: auto;\n\t\t@include mobile {\n\t\t\toverflow: auto !important;\n\t\t}\n\t\t@include desktop {\n\t\t\theight: calc(100% - 10px);\n\t\t}\n\t\t// flex-grow: 1;\n\t\tflex-direction: column;\n\t\tdisplay: flex;\n\t\tbackground-size: cover;\n\t\toverflow: hidden;\n\t\tposition: relative;\n\t\t.cross-selector {\n\t\t\tposition: absolute;\n\t\t\ttop: 15px;\n\t\t\tright: 15px;\n\t\t\tmargin: 0px;\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t\tpadding: 0px;\n\t\t\tz-index: 99;\n\t\t\tcursor: pointer;\n\t\t}\n\t\t@include mobile {\n\t\t\tborder-bottom: none;\n\t\t\tborder-bottom-left-radius: 0px;\n\t\t\tborder-bottom-right-radius: 0px;\n\t\t}\n\t}\n}\n\n.time-selection {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tpadding: 30px 18px 10px;\n\t.plump {\n\t\theight: 51px;\n\t\twidth: 54px;\n\t\tmargin-right: 24px;\n\t}\n\n\t.time-selection-text-block {\n\t\tflex-grow: 1;\n\t}\n\n\t.time-selection-text {\n\t\tfont-family: Title;\n\t\tfont-size: 32px;\n\t\tline-height: 110%;\n\t\tletter-spacing: 2%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t\tvertical-align: baseline;\n\t}\n\n\t.table-number {\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\n.order-list {\n\twidth: 100%;\n}\n\n.promo-code {\n\twidth: 100%;\n}\n.article {\n\ttext-align: center;\n\theight: 110px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t@include mobile {\n\t\theight: 35px;\n\t}\n}\n\n.ordered-articles {\n\tflex: 1;\n\toverflow-y: auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tmargin: 10px 18px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #e8e8df;\n\tborder-radius: 15px 15px 0 0;\n\n\t@include mobile {\n\t\tmin-height: 150px;\n\t}\n}\n\n.ordered-articles-container {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.title {\n\tfont-family: AppFontBold;\n\tfont-size: 25px;\n\tline-height: 21px;\n\tletter-spacing: 0em;\n\ttext-align: center;\n\tcolor: #000;\n\tmargin-bottom: 18px;\n}\n\n.promo-error {\n\tmargin: 10px;\n\tfont-size: 13px;\n\ttext-align: center;\n\tcolor: red;\n\tdisplay: none;\n}\n\n.no-articles {\n\tdisplay: flex;\n\tion-icon {\n\t\tcolor: white;\n\t\tfill: white;\n\t\tmargin-right: 10px;\n\n\t\t@include desktop {\n\t\t\tfill: black;\n\t\t\tcolor: black;\n\t\t}\n\t\tdisplay: none;\n\t\t&.big-screen {\n\t\t\t@include desktop {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t\t&.small-screen {\n\t\t\t@include mobile {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\th3 {\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFont;\n\t\tfont-size: 16px;\n\t}\n}\n.footer-finish-btn {\n\tpadding: 10px 20px;\n\n\t.footer-btn {\n\t\t&:hover {\n\t\t\t--background: var(--primary-btn) !important;\n\t\t}\n\t\twidth: 100%;\n\t\t.footer-btn-text {\n\t\t\tfont-size: 14px !important;\n\t\t\tcolor: white;\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t}\n\t}\n}\n.border-top {\n\t// border-top: 1px solid var(--color-black);\n}\n\n.finish-btn {\n\tpadding: 10px 20px;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t.footer-btn {\n\t\twidth: 100%;\n\t\t.footer-btn-text {\n\t\t\tfont-size: 14px !important;\n\t\t\tcolor: white;\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t}\n\t}\n\tborder-bottom: 1px solid #ebdfda;\n}\n.promo-section {\n\tborder-top: 1px solid var(--color-black);\n\tborder-bottom: 1px solid var(--color-black);\n\tpadding: 10px 20px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\t@include mobile {\n\t\tpadding: 5px 20px;\n\t}\n\t&.no-border {\n\t\tborder-top: none;\n\t}\n\tion-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t}\n\th3 {\n\t\tmargin-left: 10px;\n\t\tfont-size: 16px;\n\t\tfont-family: AppFont, sans-serif;\n\t\ttext-transform: uppercase;\n\t\t@include mobile {\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n}\n.tips {\n\tpadding: 10px 20px 0px;\n}\n.kaisin-points {\n\tpadding: 8px 15px;\n\n\t.wrapper-kaisin-block {\n\t\tbackground: #ebdfda;\n\t\tborder-radius: 18px;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: wrap;\n\t\t.left-info {\n\t\t\tpadding: 5px 20px;\n\t\t\twidth: 60%;\n\t\t\ttext-transform: uppercase;\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-size: 10px;\n\t\t\t\tfont-family: AppFont;\n\t\t\t}\n\t\t}\n\t\t.right-info {\n\t\t\tpadding: 5px 20px;\n\t\t\twidth: 40%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-end;\n\t\t\tion-img {\n\t\t\t\twidth: 50px;\n\t\t\t\theight: 50px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tpadding-right: 5px;\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\t\t}\n\t\t.register-section {\n\t\t\twidth: 100%;\n\t\t\tpadding: 8px 10px;\n\t\t\tborder-top: 1px solid var(--color-black);\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tion-button {\n\t\t\t\t--background: transparent;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tmin-height: 28px;\n\t\t\t\tfont-size: 12px;\n\t\t\t\twidth: 48%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.delete-promo {\n\tjustify-content: space-between;\n\t.delete-items-section {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tion-icon {\n\t\t\tmargin-left: 15px;\n\t\t}\n\t}\n}\n.form-section-input {\n\t.form-section-title {\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 20px;\n\t\tborder-top: 1px solid var(--color-black);\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t@include mobile {\n\t\t\tpadding-top: 5px;\n\t\t\tpadding-bottom: 5px;\n\t\t}\n\t\t.rotate-icon {\n\t\t\trotate: 0deg;\n\t\t\ttransition: rotate 0.5s ease-in-out;\n\t\t\t&.rotate {\n\t\t\t\trotate: 180deg;\n\t\t\t}\n\t\t}\n\t}\n\th3 {\n\t\tfont-size: 16px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--color-black);\n\t}\n\t.input-forms {\n\t\tmax-height: auto;\n\t\theight: fit-content;\n\t\ttransition: opacity 0.1s ease-in-out, max-height 0.5s cubic-bezier(0, 1, 0, 1);\n\t\t&.hide {\n\t\t\theight: 0px;\n\t\t\tmin-height: 0px;\n\t\t\tmin-height: 0px;\n\t\t\tmax-height: 0px;\n\t\t\topacity: 0;\n\t\t\toverflow: hidden;\n\t\t}\n\n\t\t.top-form-wrapper {\n\t\t\tpadding: 0 16px;\n\t\t}\n\n\t\tion-label {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.08em;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\n\t\t.title-label {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 16px;\n\t\t}\n\t}\n}\n.address-selection {\n\tpadding: 13px 20px;\n\th3 {\n\t\tfont-size: 14px;\n\t}\n}\n\n.name_row {\n\tpadding: 10px 10px 13px 15px;\n\tcolor: var(--color-black);\n\tdisplay: flex;\n\talign-items: center;\n\tborder-top: 1px solid var(--color-black);\n}\n.name-block {\n\tb {\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-main);\n\t}\n}\n\n.circle {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\twidth: 30px;\n\theight: 30px;\n\tion-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t}\n}\n\n.error_container {\n\tmargin: 0;\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n}\n\n.added-gift {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tpadding: 5px 20px;\n\tborder-bottom: 1px solid var(--color-black);\n\tcursor: pointer;\n\t.header-gift {\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tmin-height: 35px;\n\t\tmin-width: 35px;\n\t\tbackground: #f48b7f;\n\t\tborder: 1px solid var(--color-black);\n\t\tborder-radius: 50%;\n\t\tfont-size: 10px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-align: center;\n\t}\n\t.inner-text-gift {\n\t\tmargin-left: 5px;\n\t\th3 {\n\t\t\tfont-family: AppFontMedium;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 12px;\n\t\t}\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n\t.delete-items-section {\n\t\tmargin-left: auto;\n\t}\n\tion-icon {\n\t\twidth: 25px;\n\t\theight: 25px;\n\t}\n}\n.error-message {\n\ttext-align: center;\n\tcolor: var(--ion-color-secondary);\n\tpadding-bottom: 5px;\n\tfont-size: 12px;\n}\n.promo-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tcursor: pointer;\n\n\tpadding-block: 13px;\n\tmargin-inline: 18px;\n\tmargin-bottom: 10px;\n\tborder-top: 1px solid #0000004d;\n\tborder-bottom: 1px solid #0000004d;\n\n\tion-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tmargin-right: 8px;\n\t}\n\t.promo-text {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 8%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n\tion-img {\n\t\twidth: 50px;\n\t\tmargin-right: auto;\n\t}\n\t.delete-items-section {\n\t\tmargin-left: auto;\n\t}\n}\n\n.button-row {\n\tpadding: 20px 18px;\n\tborder-top: 1px solid #0000004d;\n\tborder-bottom: 1px solid #0000004d;\n}\n\n.sub-total {\n\tpadding: 0;\n\tmargin-bottom: 8px;\n\t.sub-total-title,\n\t.sub-total-sum {\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 8%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.total {\n\tpadding: 0;\n\n\t.total-title,\n\t.total-sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.total-points {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tpadding: 0px 20px;\n\ttext-transform: uppercase;\n\n\tspan {\n\t\tcolor: #f48b7f;\n\t\tfont-size: 12px;\n\t}\n}\n\n.quantity {\n  width: 25px;\n  height: 25px;\n  border: 1px solid var(--color-black);\n  border-radius: 50%;\n  background: var(--color-background-alt);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n  color: var(--color-black);\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
